import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doGetAllRoutePlans = createAsyncThunk("routePlans/doGetAllRoutePlans", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetAllRoutePlans(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateRoutePlan = createAsyncThunk("routePlans/doCreateRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateRoutePlanNonRedirect = createAsyncThunk(
  "routePlans/doCreateRoutePlanNonRedirect",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doCreateRoutePlan(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doUpdateRoutePlan = createAsyncThunk("routePlans/doUpdateRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDetailRoutePlan = createAsyncThunk("routePlans/doDetailRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDetailRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDetailRoutePlanNoFetching = createAsyncThunk(
  "routePlans/doDetailRoutePlanNoFetching",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doDetailRoutePlan(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doDeleteRoutePlan = createAsyncThunk("routePlans/doDeleteRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDeleteRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doAddOrdersRoutePlan = createAsyncThunk("routePlans/doAddOrdersRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doAddOrdersRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doRemoveOrdersRoutePlan = createAsyncThunk(
  "routePlans/doRemoveOrdersRoutePlan",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doRemoveOrdersRoutePlan(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doAddDriversRoutePlan = createAsyncThunk("routePlans/doAddDriversRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doAddDriversRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doRemoveDriversRoutePlan = createAsyncThunk(
  "routePlans/doRemoveDriversRoutePlan",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doRemoveDriversRoutePlan(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doOptimizeRoutePlan = createAsyncThunk("routePlans/doOptimizeRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doOptimizeRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateAndOptimizeRoutePlan = createAsyncThunk(
  "routePlans/doUpdateAndOptimizeRoutePlan",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdateAndOptimizeRoutePlan(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doReorderRoute = createAsyncThunk("routePlans/doReorderRoute", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doReorderRoute(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDispatchRoutePlan = createAsyncThunk("routePlans/doDispatchRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDispatchRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDuplicateRoutePlan = createAsyncThunk("routePlans/doDuplicateRoutePlan", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDuplicateRoutePlan(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetTokenRoutePlanLabel = createAsyncThunk(
  "routePlans/doGetTokenRoutePlanLabel",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doGetTokenRoutePlanLabel(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doOptimizeDuplicateRoutePlan = createAsyncThunk(
  "routePlans/doOptimizeDuplicateRoutePlan",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doOptimizeDuplicateRoutePlan(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doLockDriver = createAsyncThunk("routePlans/doLockDriver", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doLockDriver(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doEditDriver = createAsyncThunk("routePlans/doEditDriver", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doEditDriver(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doSwapOrdersToDriver = createAsyncThunk("routePlans/doSwapOrdersToDriver", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doSwapOrdersToDriver(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateIsLive = createAsyncThunk("routePlans/doUpdateIsLive", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateIsLive(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
